import { TipoMensagem } from './enum/tipo_mensagem';

export class Mensagem {
  titulo: string = null;
  tipo: TipoMensagem = null;
  mensagem: string = null;
  timeout: number = null;
  detalhe: string = null;

  constructor(d?) {
    if (d) {
      this.titulo = d.titulo ? d.titulo : null;
      this.tipo = d.tipo ? d.tipo : null;
      this.mensagem = d.mensagem ? d.mensagem : null;
      this.timeout = d.timeout ? d.timeout : null;
      this.detalhe = d.detalhe ? d.detalhe : null;
    }
  }
}
